/* import __COLOCATED_TEMPLATE__ from './datalogic.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();